<div class="components">
  <div #hostElement class="types">
    <div *ngFor="let option of pagedOptions" class="option">
      <app-isomasters-button (modularClick)="selectButton(option)" [selected]="option.selected" [style.height.px]="180">
        <div content>
          <div class="button-content">
            <div class="button-price">
              &nbsp;
              <span *ngIf="option.priceChange && isNumber(option.priceChange)">
                {{ option.priceChange | plusMinPrice }}
              </span>
              <span *ngIf="option.priceChange && !isNumber(option.priceChange)">
                {{ option.priceChange }}
              </span>
            </div>
            <div [ngClass]="{ bordered: needsBorderedFlaredImage, big: bigImagesNoBorders }" class="button-image">
              <div *ngIf="needsBorderedFlaredImage" class="flare"></div>
              <img *ngIf="option.content" [src]="option.content" width="80" />
            </div>
            <div
              #description
              (mouseenter)="showNotification(option, description)"
              (mouseleave)="hideNotification(option)"
              [id]="option.option"
              class="button-description">
              {{ option.description | translate }}
            </div>
            <div (click)="openLink($event, option.link)" *ngIf="option.link" class="info-button">
              <span
                [inlineSVG]="'assets/svg/icon-info.svg'"
                [setSVGAttributes]="{ height: '32px' }"
                class="fancy-i"></span>
            </div>
          </div>
        </div>
      </app-isomasters-button>
    </div>
  </div>
  <app-isomasters-paging
    #paging
    (pageActivated$)="pageChanged($event)"
    [elementIHaveToPage]="hostElement"
    [options]="options"
    [style.display]="hasOnlyOnePage ? 'none' : 'block'"></app-isomasters-paging>
</div>
